import { CMSContainerField } from '../cms-base-type';
import { getDefault } from './get-default';
import { readCMSValue } from './read-cms-value';

export const extractCMSOrDefault = <T>(val: T | CMSContainerField<T> | undefined, defaultVal: T): T => {
    return getDefault(readCMSValue(val), defaultVal);
};
